import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import { BoldText } from "..";
import HelpBlock from "./HelpBlock";
import classNames from 'classnames'

const Question = styled('div')`
  padding-bottom: 1em;
  
  & .question {
    display: ${props => props.inline ? 'inline-block' : 'block'};
    margin-right: 1em;
  }
  
  & .or {
    margin-right: 1em;
  }
  
  & label {
    display: inline-block;
    margin-right: 1em;
    margin-bottom: 0;
    font-weight: normal;    
  }
`;

const CheckboxQuestion = ({ question, values, selected = [], onChange, inline, showOrBeforeLastValue, children, disableOthersIfValueSelected, error, disabled, newLinePerItem }) => {

  const valueChanged = ({ currentTarget: { value, checked } }, disableOthersIfValueSelected) => {
    if (value == disableOthersIfValueSelected && checked) onChange([value])
    else onChange(checked ? [...selected, value] : selected.filter(x => x !== value));
  }

  const classes = classNames(
    'form-group',
    { 'has-error': error }
  );

  const ConditionalWrapper = ({ newLinePerItem, children, key }) => {
    return newLinePerItem ? (
      <div key={key}>{children}</div>
    ) : (
      <React.Fragment key={key}>{children}</React.Fragment>
    );
  };
  return (
    <Question className={classes} inline={inline}>
      <div className="question">{question}</div>
      {values.map((value, index, array) => (
        <ConditionalWrapper key={value} newLinePerItem={newLinePerItem}>
          {showOrBeforeLastValue && index === array.length - 1 && <BoldText className="or">Or</BoldText>}
          <input
            id={`chk-${value}`}
            value={value}
            type="checkbox"
            onChange={(event) => valueChanged(event, disableOthersIfValueSelected)}
            checked={selected.includes(value)}
            disabled={disabled || (selected.includes(disableOthersIfValueSelected) && disableOthersIfValueSelected !== value)}
          />
          <label htmlFor={`chk-${value}`}>{value}</label>

        </ConditionalWrapper>
      )
      )}
      {children}
      {error && (<HelpBlock type="error" />)}
    </Question>
  )
};

CheckboxQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  selected: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  showOrBeforeLastValue: PropTypes.bool,
  inline: PropTypes.bool,
  newLinePerItem: PropTypes.bool,
  error: PropTypes.bool,
  disableOthersIfValueSelected: PropTypes.any,
  disabled: PropTypes.bool
};

export default CheckboxQuestion;



// WEBPACK FOOTER //
// ./src/components/forms/CheckboxQuestion.js